module.exports = __webpack_public_path__ + "static/media/background-photo2048.bd570cb3.jpg";